<template>
  <section>
    <base-section-title>#{{ $t('homepage.skills') }}'</base-section-title>
    <tabs-container class="pt-3">
      <tab-element :active="true" :title="$t('homepage.skills-cat')[0]">
        <base-skills-group>
          <base-skill-item skill="HTML & CSS" :percentage="95"/>
          <base-skill-item skill="JavaScript" :percentage="90"/>
          <base-skill-item skill="VueJS" :percentage="55"/>
          <base-skill-item skill="PHP" :percentage="89"/>
          <base-skill-item skill="LARAVEL" :percentage="70"/>
          <base-skill-item skill="DOCKER" :percentage="50"/>
          <base-skill-item skill="SPRING" :percentage="65"/>
        </base-skills-group>
      </tab-element>
      <tab-element :title="$t('homepage.skills-cat')[1]">
        <base-skills-group>
          <base-skill-item skill="Python" :percentage="95"/>
          <base-skill-item skill="Tableau" :percentage="75"/>
          <base-skill-item skill="Artificial Intelligence" :percentage="55"/>
          <base-skill-item skill="Data Mining" :percentage="50"/>
          <base-skill-item skill="Machine Learning" :percentage="70"/>
          <base-skill-item skill="Business Intelligence" :percentage="60"/>
        </base-skills-group>
      </tab-element>
    </tabs-container>
  </section>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'
import BaseSkillsGroup from '../../base/skills/BaseSkillsGroup'
import BaseSkillItem from '../../base/skills/BaseSkillItem'
import TabElement from '../../base/tab/TabElement'
import TabsContainer from '../../base/tab/TabsContainer'
export default {
  name: 'SkillsSection',
  components: { TabsContainer, TabElement, BaseSkillItem, BaseSkillsGroup, BaseSectionTitle }
}
</script>

<style scoped>

</style>
